import { motion } from 'framer-motion';
import { SectionCard, Field, MultiSelect, RadioSelect, inputClass } from '@/components/SurveyComponents';
import type { SurveyData } from '@/lib/index';

interface Props { data: SurveyData; update: (d: Partial<SurveyData>) => void; }

const AGE_RANGES = ['21–25','26–30','31–35','36–40','41–50','50+'];
const RELATIONSHIPS = ['Close friends','College friends','Coworkers','Family members','A mix','Just met / new friends'];
const OCCASIONS = ['Bachelorette / Bridal Party','Birthday celebration','Anniversary','Girls trip (no occasion)','Graduation','Retirement','Just because we deserve it','Other'];
const EXPERIENCE = ['First group trip together','We travel together sometimes','We travel together all the time','Mix of experienced and first-timers'];

export function Step2Group({ data, update }: Props) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-5">
      <div className="text-center mb-4">
        <h2 className="font-serif text-2xl font-bold text-foreground">Tell me about your group 👯</h2>
        <p className="text-muted-foreground text-sm mt-1">The more I know, the better I can plan.</p>
      </div>

      <SectionCard title="Contact Info" emoji="📬">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field label="Your Name" required>
            <input className={inputClass} placeholder="First & last name" value={data.name} onChange={e => update({ name: e.target.value })} />
          </Field>
          <Field label="Email Address" required>
            <input className={inputClass} type="email" placeholder="you@email.com" value={data.email} onChange={e => update({ email: e.target.value })} />
          </Field>
          <Field label="Instagram Handle" hint="So I can get a feel for your aesthetic!">
            <input className={inputClass} placeholder="@yourusername" value={data.instagram} onChange={e => update({ instagram: e.target.value })} />
          </Field>
          <Field label="How did you find Mapped by Mattie?">
            <input className={inputClass} placeholder="Instagram, TikTok, friend referral..." value={data.referral} onChange={e => update({ referral: e.target.value })} />
          </Field>
        </div>
      </SectionCard>

      <SectionCard title="Group Details" emoji="👥">
        <Field label="How many people are traveling?" required>
          <RadioSelect options={['2–4 people','5–6 people','7–8 people','9–10 people','10+ people']} value={data.groupSize} onChange={v => update({ groupSize: v })} />
        </Field>
        <Field label="Age range(s) in the group" hint="Select all that apply">
          <MultiSelect options={AGE_RANGES} selected={data.ageRange} onChange={v => update({ ageRange: v })} cols={3} />
        </Field>
        <Field label="Relationship to each other" required>
          <RadioSelect options={RELATIONSHIPS} value={data.groupRelationship} onChange={v => update({ groupRelationship: v })} cols={2} />
        </Field>
        <Field label="Is there a special occasion?" required>
          <RadioSelect options={OCCASIONS} value={data.occasion} onChange={v => update({ occasion: v })} cols={2} />
        </Field>
        <Field label="Group's travel experience together">
          <RadioSelect options={EXPERIENCE} value={data.travelExperience} onChange={v => update({ travelExperience: v })} cols={1} />
        </Field>
      </SectionCard>
    </motion.div>
  );
}
